import Highcharts from "./highchartsSetup";
import HighchartsReact from "highcharts-react-official";

export const getChartImageUrl = (
    ref: React.RefObject<HighchartsReact.RefObject>
): Promise<string> => {
    const chart = ref.current?.chart as Highcharts.Chart | undefined;

    if (!chart) {
        return Promise.reject(new Error("Chart not ready"));
    }

    // 1. Get SVG from Highcharts
    const svg = chart.getSVG();

    // 2. Convert SVG to PNG data URL via canvas
    return new Promise<string>((resolve, reject) => {
        const blob = new Blob([svg], { type: "image/svg+xml;charset=utf-8" });
        const url = URL.createObjectURL(blob);
        const img = new Image();

        img.onload = () => {
            try {
                const canvas = document.createElement("canvas");
                canvas.width = chart.chartWidth;
                canvas.height = chart.chartHeight;
                const ctx = canvas.getContext("2d");
                if (!ctx) {
                    reject(new Error("Could not get 2D context"));
                    return;
                }
                ctx.drawImage(img, 0, 0);
                URL.revokeObjectURL(url);
                const dataUrl = canvas.toDataURL("image/png");
                resolve(dataUrl);
            } catch (e) {
                reject(e);
            }
        };

        img.onerror = (e) => {
            URL.revokeObjectURL(url);
            reject(e);
        };

        img.src = url;
    });
};